<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinnerGuardar" [disabled]="!habilitarGuardar" (click)="saveSolicitud()" type="button" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinnerGuardar" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>

            <!--<button class="btn btn-outline-success" (click)="cargarDatosPrueba()"><i class="fa fa-long-arrow-up"></i> CARGAR DATOS</button>-->
            <!--<button class="btnback btn btn-outline-success" *ngIf="!visibilitySpinnerGuardar" type="button" (click)="generarCpe()"><i class="fa fa-file-pdf-o"></i> Generar CPE</button>
            <button *ngIf="visibilitySpinnerGuardar" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Generando CPE
            </button>-->
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Certificado Previo de Exportación {{codigoCpe}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudAtestFito}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{form.value.IdEstadoCpe | IconoEstadoSolicitudCpe}}" ngbTooltip="{{tituloEstadoSolicitudCpe}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <!--DETALLE CPE-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn" style="margin-top: 3px">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Detalle Certificado Previo Exportación
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Comunidad Autónoma</label>
                                            <ng-select [items]="listComunidad"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdComunidadAutonoma"
                                                       loadingText="Cargando..."
                                                       [loading]="!listComunidad"
                                                       notFoundText="Comunidad Autónoma no encontrada"
                                                       placeholder="-- Seleccione una Comunidad Autónoma --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--DATOS OPERADOR PROFESIONAL-->
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedOperador = !isCollapsedOperador" [attr.aria-expanded]="!isCollapsedOperador" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Operador Profesional
                                    <i *ngIf="isCollapsedOperador" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedOperador" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">

                                <div class="collapse group-filtros" id="collapsedOperador" [ngbCollapse]="isCollapsedOperador">

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">NIF</label>
                                            <div class="input-group">
                                                <input formControlName="NifOperador" name="NifOperador" title="" class="form-control" maxlength="9"
                                                       [ngClass]="displayFieldCss('NifOperador')" id="" type="text" value="">
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifOperador','required')">
                                                NIF es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifOperador','NIF')">
                                                Formato de NIF incorrecto
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="">Nombre</label>
                                            <input formControlName="NombreOperador" name="NombreOperador" [ngClass]="displayFieldCss('NombreOperador')" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="300">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreOperador','required')">
                                                Nombre es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Provincia</label>
                                            <ng-select [items]="listProvincia"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdProvinciaOperador"
                                                       loadingText="Cargando..."
                                                       [loading]="!listProvincia"
                                                       notFoundText="Provincia no encontrada"
                                                       placeholder="-- Seleccione una Provincia --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvinciaOperador','required')">
                                                Provincia es obligatoria
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Localidad</label>
                                            <input formControlName="LocalidadOperador" name="LocalidadOperador" [ngClass]="displayFieldCss('LocalidadOperador')" title="" class="form-control" id="inpCiudad" type="text" value="" maxlength="100">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('LocalidadOperador','required')">
                                                Localidad es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="">Dirección</label>
                                            <input formControlName="DireccionOperador" name="DireccionOperador" [ngClass]="displayFieldCss('DireccionOperador')" title="" class="form-control" id="inpDireccion" type="text" value="" maxlength="250">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DireccionOperador','required')">
                                                Dirección es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Código Postal</label>
                                            <input formControlName="CodigoPostalOperador" name="CodigoPostalOperador" [ngClass]="displayFieldCss('CodigoPostalOperador')" title="" class="form-control" id="" type="text" value="" maxlength="15">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalOperador','required')">
                                                Código Postal es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--OTROS DATOS CPE-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn" style="margin-top: 3px">
                            <a class="card-header-a" (click)="isCollapsedOtrosDatos = !isCollapsedOtrosDatos" [attr.aria-expanded]="!isCollapsedOtrosDatos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Otros Datos
                                    <i *ngIf="isCollapsedOtrosDatos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedOtrosDatos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedOtrosDatos" [ngbCollapse]="isCollapsedOtrosDatos">
                                    <div class="row" style="margin-bottom:15px;">

                                        <div class="form-group col-md-12">
                                            <!-- required-field -->
                                            <label class="col-form-label" for="">Observaciones</label>
                                            <textarea formControlName="Observaciones" name="Observaciones" title="" class="form-control"
                                                      id="" type="text" value="" autoResize="autoResize" rows="12"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!--DATOS DEL ENVÍO DE LA SOLICITUD-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosEnvio = !isCollapsedDatosEnvio" [attr.aria-expanded]="!isCollapsedDatosEnvio" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos del envío de la solicitud
                                    <i *ngIf="isCollapsedDatosEnvio" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosEnvio" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosEnvio" [ngbCollapse]="isCollapsedDatosEnvio">
                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpFecha">Fecha Envío: </label>
                                            <input formControlName="FechaEnvio" name="FechaEnvio" readonly title="" class="form-control" id="" value="">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="">Codigo: </label>
                                            <input formControlName="Codigo" name="Codigo" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="">Nº Certificado: </label>
                                            <input formControlName="NumeroCertificado" name="NumeroCertificado" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
